module.exports = __webpack_public_path__ + "static/media/highschool.1186c519.png";